import { z } from "zod/v4";
import { parseDDNStringAsDDN, parseMobileNumberAsE164, parserToValidator, } from "vincent-utils/dist/parsers.js";
export const NewAptRequestSchema = z.object({
    patient_id: z.string(),
    object: z.string(),
    public_object: z.string(),
    duration: z.number().gt(0).int(),
    canceled: z.boolean(),
    type: z.number().gt(0).int(),
    reminderChecked: z.boolean(),
    confirmChecked: z.boolean(),
    apt_id: z.string().nullable(),
});
export const ExistingAptRequestSchema = NewAptRequestSchema.extend({
    id: z.string(),
    owner: z.string(),
});
export const AptRequestSchemaLimited = ExistingAptRequestSchema.pick({
    id: true,
    patient_id: true,
    apt_id: true,
    public_object: true,
    duration: true,
    canceled: true,
    type: true,
});
const ddnValidator = parserToValidator(parseDDNStringAsDDN);
export const DDNSchema = z
    .string()
    .length(10)
    .transform((val, ctx) => {
    if (!ddnValidator(val)) {
        ctx.addIssue({ message: "Invalid date", code: "custom" });
    }
    return val;
})
    .brand();
const e164Validator = parserToValidator(parseMobileNumberAsE164);
export const E164Schema = z
    .string()
    .min(2)
    .transform((val, ctx) => {
    if (!e164Validator(val)) {
        ctx.addIssue({
            message: "Invalid e164 phone number",
            code: "custom",
        });
        return z.NEVER;
    }
    const parsed = parseMobileNumberAsE164(val);
    return parsed;
})
    .brand();
//# sourceMappingURL=Schemas.js.map